import redirectRules from './redirect-rules';
import { getSpecialRedirectMatch } from './redirect-special-cases';

type RedirectRule = {
    from: string | RegExp;
    to: string;
    code?: number;
};

export type RedirectMatch = {
    to: string;
    code: number;
};

const rules = redirectRules as RedirectRule[];

export const getRedirectMatch = (pathname: string, search: string): RedirectMatch | null => {
    const specialMatch = getSpecialRedirectMatch(pathname, search);

    if (specialMatch) {
        return specialMatch;
    }

    const byExact = rules.find((rule) => typeof rule.from === 'string' && rule.from === pathname);

    if (byExact) {
        return {
            to: `${byExact.to}${search}`,
            code: byExact.code ?? 302,
        };
    }

    const patterns = rules.filter((rule) => rule.from instanceof RegExp);

    const matchedPattern = patterns.find(
        (rule) => rule.from instanceof RegExp && rule.from.test(pathname),
    );

    if (matchedPattern && matchedPattern.from instanceof RegExp) {
        const targetPath = pathname.replace(matchedPattern.from, matchedPattern.to);
        const questionMarkIndex = targetPath.indexOf('?');
        const targetBasePath =
            questionMarkIndex === -1 ? targetPath : targetPath.slice(0, questionMarkIndex);
        const targetQueryString =
            questionMarkIndex === -1 ? '' : targetPath.slice(questionMarkIndex + 1);
        const finalParams = new URLSearchParams(targetQueryString);
        const requestQueryString = search.startsWith('?') ? search.slice(1) : search;

        if (requestQueryString) {
            const requestParams = new URLSearchParams(requestQueryString);

            requestParams.forEach((value, key) => {
                if (!finalParams.has(key)) {
                    finalParams.append(key, value);
                }
            });
        }

        const mergedQueryString = finalParams.toString();
        const finalUrl = `${targetBasePath}${mergedQueryString ? `?${mergedQueryString}` : ''}`;

        return {
            to: finalUrl,
            code: matchedPattern.code ?? 302,
        };
    }

    return null;
};
